import { render, staticRenderFns } from "./pricing-table-icon.vue?vue&type=template&id=373ddb50&scoped=true&"
import script from "./pricing-table-icon.vue?vue&type=script&lang=js&"
export * from "./pricing-table-icon.vue?vue&type=script&lang=js&"
import style0 from "./pricing-table-icon.vue?vue&type=style&index=0&id=373ddb50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ddb50",
  null
  
)

export default component.exports